import {useTranslation} from 'react-i18next'
import {NativeSelect} from '@/components/native-select'
import {Label} from '@/components/ui/label'
import {
  TIPOS_COMPETENCIA,
  TIPOS_REQUISITO,
  type Bloque,
  type ExtrasCrudos,
  type TipoCompetencia,
  type TipoRequisito,
} from '@/lib/perfil-bloques'

export function PerfilLineaExtras({
  bloque,
  valor,
  onChange,
}: {
  bloque: Bloque
  valor: ExtrasCrudos
  onChange: (extras: ExtrasCrudos) => void
}) {
  const {t} = useTranslation()
  const set = (parte: Partial<ExtrasCrudos>) => onChange({...valor, ...parte})
  return (
    <>
      {bloque === 'requerimientos' && (
        <div className="space-y-2">
          <Label htmlFor="perfil-nuevo-tipo">{t('perfilCargo.detalle.tipoRequisito')}</Label>
          <NativeSelect
            id="perfil-nuevo-tipo"
            data-testid="perfil-nuevo-tipo"
            value={valor.tipo}
            onChange={(event) => set({tipo: event.target.value as TipoRequisito})}>
            {TIPOS_REQUISITO.map((tipo) => (
              <option key={tipo} value={tipo}>
                {t(`perfilCargo.subtipo.${tipo}`)}
              </option>
            ))}
          </NativeSelect>
        </div>
      )}
      {bloque === 'competencias' && (
        <div className="space-y-2">
          <Label htmlFor="perfil-nuevo-tipo-competencia">{t('perfilCargo.detalle.tipoCompetencia')}</Label>
          <NativeSelect
            id="perfil-nuevo-tipo-competencia"
            data-testid="perfil-nuevo-tipo-competencia"
            value={valor.tipoCompetencia}
            onChange={(event) => set({tipoCompetencia: event.target.value as TipoCompetencia})}>
            {TIPOS_COMPETENCIA.map((tipo) => (
              <option key={tipo} value={tipo}>
                {t(`perfilCargo.subtipo.${tipo}`)}
              </option>
            ))}
          </NativeSelect>
        </div>
      )}
    </>
  )
}
